import { FilePath } from 'app/model/dataset/file-path';
import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Location } from 'app/model/dataset/location/location';
import { HttpServerLinkedService } from 'app/model/linkedservice/http-server.linkedservice';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { ILocationPath, isLogicAppExpression } from 'shell-models-lib';

@Metamodel.model({
    name: 'HttpServerLocation',
    tags: {
        linkedServiceModel: Metamodel.modelFor(HttpServerLinkedService)
    }
})
export class HttpServerLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly RELATIVE_URL: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Dataset_RelativeUrl,
        association: 'RELATIVE_URL',
        templatable: true
    })
    public relativeUrl?: string;

    public setLocation(path: FilePath): void {
        this.relativeUrl = path.fileName;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        if (isLogicAppExpression(path.fileName)) {
            HttpServerLocation.RELATIVE_URL.setTemplateValue(this, path.fileName);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (this as any)['relativeUrl'] = path.fileName;
        }
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.fileName = this.relativeUrl;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            fileName: HttpServerLocation.RELATIVE_URL.templateValue(this) || this.relativeUrl
        };
    }

    public getFolderPath(): string {
        return this.relativeUrl;
    }

    public isFolder(): boolean {
        return false;
    }

    public isLocationParameterized(): boolean {
        return !stringIsNullOrEmpty(HttpServerLocation.RELATIVE_URL.templateValue(this));
    }
}
